import { Component, Prop, Vue } from "vue-property-decorator";

// External components
import ModalBase from "@/components/modalBase/modalBase";
import Loading from "@/components/loading/loading";
import ApplyCouponInput from "../applyCouponInput/applyCouponInput";

@Component({
  components: {
    ModalBase,
    Loading,
    ApplyCouponInput,
  },
})
export default class ModalCoupon extends Vue {
  @Prop({ default: false }) isActive!: Boolean;

  isLoading = false;
}
